module.exports = __webpack_public_path__ + "img/44.1a18f113.png";